import { createSlice } from '@reduxjs/toolkit';

const setActiveTabSlice = createSlice({
    name: 'activeTab',
    initialState: {
        tab: '',
    },
    reducers: {
        setActiveTab: (state, action) => {
            state.tab = action.payload;
        },
    },
});

export const { setActiveTab } = setActiveTabSlice.actions;
export default setActiveTabSlice.reducer;
